module.exports = __webpack_public_path__ + "img/reset_step2.525dca6c.png";